/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Color_Role_SecondaryInputs */

const en_enum_color_role_secondary = /** @type {(inputs: Enum_Color_Role_SecondaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Role Secondary`)
};

const de_enum_color_role_secondary = /** @type {(inputs: Enum_Color_Role_SecondaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Role Secondary`)
};

/**
* | output |
* | --- |
* | "Role Secondary" |
*
* @param {Enum_Color_Role_SecondaryInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const enum_color_role_secondary = /** @type {((inputs?: Enum_Color_Role_SecondaryInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Color_Role_SecondaryInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_color_role_secondary(inputs)
	return de_enum_color_role_secondary(inputs)
});